import { render, staticRenderFns } from "./VwDetails.vue?vue&type=template&id=3f74449a&scoped=true&lang=pug&"
import script from "./VwDetails.vue?vue&type=script&lang=ts&"
export * from "./VwDetails.vue?vue&type=script&lang=ts&"
import style0 from "./VwDetails.vue?vue&type=style&index=0&id=3f74449a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f74449a",
  null
  
)

component.options.__file = "VwDetails.vue"
export default component.exports